import { axiosInstance } from '@configs/axios/axiosInstance';

import type { InvoiceItem } from '../types/invoice.types';
import type {
  GetInvoicesRequest,
  GetInvoicesResult,
} from './getInvoices.types';

export async function getInvoices({
  organizationId,
  sort,
  top,
  skip,
  searchText,
  dueDateStart,
  dueDateEnd,
  issuedOnStartDate,
  issuedOnEndDate,
  balanceStatus,
  currency,
  platform,
  location,
}: GetInvoicesRequest): Promise<GetInvoicesResult> {
  const params: Record<string, string | number | string[] | undefined> = {
    sort,
    top,
    skip,
  };
  if (searchText) params.searchText = searchText;
  if (dueDateStart) params.dueDateStart = dueDateStart;
  if (dueDateEnd) params.dueDateEnd = dueDateEnd;
  if (issuedOnStartDate) params.issuedOnStartDate = issuedOnStartDate;
  if (issuedOnEndDate) params.issuedOnEndDate = issuedOnEndDate;
  if (balanceStatus?.length) params.balanceStatus = balanceStatus;
  if (currency?.length) params.currency = currency;
  if (platform?.length) params.platform = platform;
  if (location?.length) params.location = location;

  const response = await axiosInstance.get<InvoiceItem[]>('/invoices', {
    headers: {
      'X-Organization-Id': organizationId,
    },
    params,
  });

  const xTotalCount = response.headers['x-total-count'];
  const total =
    xTotalCount !== undefined ? Number(xTotalCount) : response.data.length;

  return { elements: response.data, total };
}
